import { createGlobalStyle } from "styled-components";

const RightSidebarStyle = createGlobalStyle`
    .custom-timepicker input{
        boarder-color: #BDFF00;
        color: white;
    }
    .custom-timepicker input::placeholder {
        color: white;
        opacity: 1;
    }
    .custom-timepicker input::focus {
        boarder-color: #BDFF00;
    }
    .dark-overlay{
        background: #000000;
        opacity: 0.5;
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 9;
    }
    .right-sidebar-wrap-close{
        right: -500px!important;
        transition: all 0.25s linear 0s;
    }
    .right-sidebar-wrap{
        width: 492px;
        position: fixed;
        top: 0;
        right: 0;
        height: 100%;
        padding: 28px 23px;
        z-index: 9;
        transition: all 0.25s linear 0s;
        .icon-import-img{
            width: 100px;
            height: 100px;
        }
        .select-style{
            background: #3C3C3C;
            border-radius: 6px;
            height: 49px;
            padding: 2px 15px;
            color:  #A0A0A0;
            border: none;
            -webkit-appearance: none;
            :focus{
                outline : none;
            }
        }
        .sidebar-form-wrap{
            overflow: auto;
            height: calc(100% - 5px);
            -ms-overflow-style: none;
            scrollbar-width: none;
            ::-webkit-scrollbar {
                display: none;
            }
            textArea{
                background: #3C3C3C;
                border: 1px solid #3c3c3c;
                padding: 10px 15px;
                outline: none;
                color: #fff;
                border-radius: 6px;
                height: 102px;
                transition: all 0.25s linear 0s;
                :focus, :hover {
                    outline: none;
                    border: 1px solid #A0A0A0;
                }
            }
            input[type="file"] {
                display: none;
            }
        }
    }

    .ant-picker-range .ant-picker-active-bar {
    background:#BDFF00}
    .Time-wrapper{
        .react-timekeeper__top-bar{
            background: #282828;
            .react-timekeeper-button-reset{
                color : white;
                opacity: 0.5;
            }
            .react-timekeeper__tb-minute-wrapper{
                .react-timekeeper__tb-hour{
                    color: #FFFFFF;
                    opacity: 0.5;
                }
                .react-timekeeper__tb-hour--active{
                    opacity: 1;
                }
            }
            .react-timekeeper__tb-hour-wrapper{
                .react-timekeeper__tb-minute{
                    color: #FFFFFF;
                    opacity: 0.5;
                }
                .react-timekeeper__tb-minute--active{
                    opacity: 1;
                }
            }
        }
        .react-timekeeper__clock-wrapper{
            background: #646464;
            .react-timekeeper__clock{
                background: #282828;
                .react-timekeeper__clock-minutes{
                    color: white;
                }
                .react-timekeeper__clock-hand{
                    stroke: var(--hand-line-color,#BDFF00);
                }
                .react-timekeeper__hand-circle-center{
                    fill: var(--hand-circle-center,#BDFF00);

                }
                .react-timekeeper__hand-circle-outer{
                    fill: var(--hand-circle-outer,#BDFF00);
                }
            }
            .react-timekeeper-button-reset{
                color: #282828;
            }
            .react-timekeeper__meridiem-toggle{
                background:  #A0A0A0;                
            }
            .react-timekeeper__meridiem--active{
                background:  #BDFF00;
            }
        }
        .input-time{
            background-position: center right;
            background-repeat: no-repeat;
            background-origin: content-box;
        }
        .time-wrap-div{
            top: -210px;
            z-index: 99;
        }
    }
`;

export default RightSidebarStyle;